/**
 *  Form component both participants
 *  @module Widgets
 *  @author Livescore <info@score-stats.com>
 *  @copyright 2021 livescore
 */

import { Component, Input, OnInit } from '@angular/core';

import { BetsOddTypes, OddsAndMarkets, OddsSingle } from '@interfaces/bets-market.interface';

import { LastForm } from '@/modules/widgets/interfaces/widget.interface';

const num = 10;

@Component({
    selector: 'app-widget-win-probability',
    templateUrl: './win-probability.component.html',
})
export class WinProbabilityParticipantsComponent implements OnInit {
    @Input() home: string;
    @Input() away: string;
    @Input() draw: string;

    @Input() odds: number[];


    @Input()
        formHome: LastForm[];

    @Input()
        formAway: LastForm[];


    @Input()
    public otherOdds: OddsAndMarkets = [];


    public count: number;

    formH: LastForm[] = [];
    formA: LastForm[] = [];

    public homePrct: number = 0;
    public awayPrct: number = 0;
    public drawPrct: number = 0;

    public ngOnInit(): void {
        this.formHome = this.formHome.filter((v:LastForm) => v.home_team === this.home).slice(0, num);
        this.formAway = this.formAway.filter((v:LastForm) => v.away_team === this.away).slice(0, num);

        let home = 0;
        let away = 0;
        // let draw = 0;

        this.count = Math.min(this.formHome.length, this.formAway.length);

        for (let x = 0; x < this.count; x += 1) {
            const hStatus = this.formHome[x].status;
            const aStatus = this.formAway[x].status;

            if (hStatus === 'win') {
                home += 1;
            }
            if (hStatus === 'lose') {
                away += 1;
            }
            if (aStatus === 'win') {
                away += 1;
            }
            if (aStatus === 'lose') {
                home += 1;
            }
            if (hStatus === 'draw') {
                // draw += 1;
            }
            if (aStatus === 'draw') {
                // draw += 1;
            }
        }

        if (this.isOdssValid) {
            const min = Math.min(...this.odds);

            let sum = 0;

            this.odds.forEach((val, key) => {
                if (val !== min) {
                    this.odds[key] = min / (val / min);
                    sum += this.odds[key];
                }
            });

            this.odds.forEach((val, key) => {
                if (val === min) {
                    sum += this.odds[key];
                }
            });

            if (this.oddsLength === 3) {
                this.homePrct = (this.odds[0] / sum) * 100;
                this.awayPrct = (this.odds[2] / sum) * 100;
                this.drawPrct = Math.max(100 - (Math.round(this.homePrct) + Math.round(this.awayPrct)), 0);
            } else if (this.oddsLength === 2) {
                this.homePrct = (this.odds[0] / sum) * 100;
                this.awayPrct = (this.odds[1] / sum) * 100;
            }
        } else {
            this.homePrct = (home / (this.count * 2)) * 100;
            this.awayPrct = (away / (this.count * 2)) * 100;
            if (Math.round(this.homePrct) + Math.round(this.awayPrct) > 100) {
                if (this.homePrct > this.awayPrct || this.homePrct === this.awayPrct) {
                    this.awayPrct -= 1;
                } else {
                    this.homePrct -= 1;
                }
            }

            this.drawPrct = Math.max(100 - (Math.round(this.homePrct) + Math.round(this.awayPrct)), 0);
        }
        this.homePrct += 0.02;
        this.awayPrct += 0.01;
        this.drawPrct = Math.max(100 - (Math.round(this.homePrct) + Math.round(this.awayPrct)), 0);
    }

    get marketsAndOdds(): {marketName: string;odds:{name: string; rate:number|string;percentage: number}[]}[] {
        if (!this.otherOdds) {
            return [];
        }
        return this.otherOdds.map((odd: OddsSingle) => {
            const odds: {name: string; rate:number|string;percentage: number}[] = [];

            const sum = odd.odds.odd_types.reduce((acc, b: BetsOddTypes) => acc + +b.rate, 0);


            odd.odds.odd_types.forEach((b: BetsOddTypes) => {
                const market = odd.market.odd_types.find(o => o.id === b.id);
                if (market) {
                    odds.push({ rate: b.rate, name: market.name, percentage: (+b.rate / sum) * 100 });
                }
            });

            return { marketName: odd.market.name_tech, odds };
        }) ?? [];
    }

    get oddsSum(): number {
        if (this.isOdssValid) {
            return this.odds.reduce((acc, cur) => acc + cur);
        }
        return 0;
    }

    get isOdssValid(): boolean {
        return this.odds && Array.isArray(this.odds) && this.odds.length >= 2 && this.odds.length <= 3;
    }

    get oddsLength(): number { return this.odds.length; }

    get select1(): string {
        if (this.sort[0] === this.homePrct) {
            return this.home;
        }
        if (this.sort[0] === this.awayPrct) {
            return this.away;
        }
        return this.draw;
    }

    get select2(): string {
        if (this.sort[1] === this.homePrct) {
            return this.home;
        }
        if (this.sort[1] === this.awayPrct) {
            return this.away;
        }
        return this.draw;
    }

    get select3(): string {
        if (this.sort[2] === this.homePrct) {
            return this.home;
        }
        if (this.sort[2] === this.awayPrct) {
            return this.away;
        }
        return this.draw;
    }


    get sort(): number[] {
        if (this.oddsLength === 2) {
            return [this.homePrct, this.awayPrct];
        }
        return [this.homePrct, this.drawPrct, this.awayPrct];
    }

    public trackByIndex(index: any): any {
        return index;
    }

    public trackByName(index: number, val: Record<string, any>): any {
        return val.marketName;
    }
}
